/* eslint-disable */
// https://dev2.bhsn.it/api/aistudio/swagger-ui/index.html
import type { AxiosPromise, AxiosInstance } from 'axios';
import { toAxiosOptions, mergeObjects } from '@allibee/utils';

let axiosInstance: AxiosInstance;
let baseURL: string;

const serviceRoute = 'aistudio';
export function setupServiceInstance(callback: (serviceRoute: string) => { baseURL: string; instance: AxiosInstance }) {
    const result = callback(serviceRoute);
    axiosInstance = result.instance;
    baseURL = result.baseURL;
}

export function getBaseURL() {
    return baseURL;
}

/**
 * @returns AistudioAiStudioResponseAdminRuleDto OK
 * @throws ApiError
 */
export function getAdminRule(
    {
        govId,
        serialNumber,
        effectiveDate,
    }: {
        govId: string;
        serialNumber?: string;
        effectiveDate?: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseAdminRuleDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/admin-rules/v1',
                query: {
                    govId: govId,
                    serialNumber: serialNumber,
                    effectiveDate: effectiveDate,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Agent 통합 실행 수정
 * @returns AistudioAgentRunResponseDto 기존 대화를 수정하여 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function editAgent(
    {
        chatKey,
        chatMessageKey,
        requestBody,
    }: {
        chatKey: string;
        chatMessageKey: string;
        requestBody: AistudioAgentRunUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAgentRunResponseDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/agents/{chatKey}/run-histories/{chatMessageKey}/v1',
                path: {
                    chatKey: chatKey,
                    chatMessageKey: chatMessageKey,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 통합 메시지 피드백 조회
 * @returns AistudioAiStudioResponseAgentRunHistoryFeedbackDto OK
 * @throws ApiError
 */
export function getAgentRunHistoryFeedback(
    {
        chatKey,
        chatMessageKey,
    }: {
        chatKey: string;
        chatMessageKey: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseAgentRunHistoryFeedbackDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/agents/{chatKey}/run-histories/{chatMessageKey}/feedbacks/v1',
                path: {
                    chatKey: chatKey,
                    chatMessageKey: chatMessageKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 통합 메시지 피드백
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function createAgentRunHistoryFeedback(
    {
        chatKey,
        chatMessageKey,
        requestBody,
    }: {
        chatKey: string;
        chatMessageKey: string;
        requestBody: AistudioAgentRunHistoryFeedbackForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/agents/{chatKey}/run-histories/{chatMessageKey}/feedbacks/v1',
                path: {
                    chatKey: chatKey,
                    chatMessageKey: chatMessageKey,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Agent 캔버스 버전 업
 * @returns AistudioAiStudioResponseListAgentRunHistoryDto OK
 * @throws ApiError
 */
export function createCanvasNewVersion(
    {
        chatKey,
        requestBody,
    }: {
        chatKey: string;
        requestBody: AistudioCanvasVersionForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListAgentRunHistoryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/agents/{chatKey}/canvas-versions/v1',
                path: {
                    chatKey: chatKey,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Agent 통합 실행
 * @returns AistudioAgentRunResponseDto 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function runAgent(
    {
        requestBody,
    }: {
        requestBody: AistudioAgentRunForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAgentRunResponseDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/agents/run/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 통합 메시지 피드백 목록 조회
 * @returns AistudioAiStudioResponseListAgentRunHistoryFeedbackDto OK
 * @throws ApiError
 */
export function listAgentRunHistoryFeedbacks(
    {
        chatKey,
    }: {
        chatKey: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListAgentRunHistoryFeedbackDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/agents/{chatKey}/run-histories/feedbacks/v1',
                path: {
                    chatKey: chatKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Agent 통합 이력 조회
 * @returns AistudioAiStudioResponseListAgentRunHistoryDto OK
 * @throws ApiError
 */
export function getAgentRunHistories(
    {
        chatKey,
    }: {
        chatKey: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListAgentRunHistoryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/agents/run-histories/{chatKey}/v1',
                path: {
                    chatKey: chatKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 조문 연혁 조회
 * @returns AistudioAiStudioResponseListStatuteSimpleDto OK
 * @throws ApiError
 */
export function getStatuteHistoriesV2(
    {
        statuteId,
    }: {
        statuteId: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListStatuteSimpleDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/statutes/{statuteId}/histories/v2',
                path: {
                    statuteId: statuteId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * @returns AistudioAiStudioResponseListStatuteHistoryDto OK
 * @throws ApiError
 */
export function getStatuteHistories(
    {
        statuteId,
    }: {
        statuteId: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListStatuteHistoryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/statutes/{statuteId}/histories/v1',
                path: {
                    statuteId: statuteId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 법령 조문 연혁 조회
 * 법령 ID와 조문 Key를 이용하여 법령 조문을 조회합니다.
 * @returns AistudioAiStudioResponseListStatuteClauseHistoryDto OK
 * @throws ApiError
 */
export function getClauseHistories(
    {
        statuteId,
        clauseKey,
    }: {
        /**
         * 법령 ID
         */
        statuteId: string;
        /**
         * 조문 Key
         */
        clauseKey: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListStatuteClauseHistoryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/statutes/{statuteId}/clauses/{clauseKey}/histories/v1',
                path: {
                    statuteId: statuteId,
                    clauseKey: clauseKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 법령 전문 조회
 * @returns AistudioAiStudioResponseStatuteWithClausesDto OK
 * @throws ApiError
 */
export function getStatute(
    {
        lawSerialNumber,
        effectiveDate,
    }: {
        lawSerialNumber: string;
        effectiveDate: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseStatuteWithClausesDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/statutes/v1',
                query: {
                    lawSerialNumber: lawSerialNumber,
                    effectiveDate: effectiveDate,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 연혁 단건의 상세 정보 조회 with 조문 tree 구조
 * @returns AistudioAiStudioResponseStatuteHistoryDto OK
 * @throws ApiError
 */
export function getStatuteHistoryDetails(
    {
        lawSerialNumber,
        effectiveDate,
    }: {
        lawSerialNumber: string;
        effectiveDate: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseStatuteHistoryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/statutes/histories/details/v1',
                query: {
                    lawSerialNumber: lawSerialNumber,
                    effectiveDate: effectiveDate,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 첨부파일 업로드
 * @returns AistudioAiStudioResponseChatAttachmentDto OK
 * @throws ApiError
 */
export function uploadChatAttachment(
    {
        formData,
    }: {
        formData?: {
            file: Blob;
            form: AistudioChatAttachmentUploadForm;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseChatAttachmentDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/chats/attachments/upload/v1',
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 첨부파일 조회
 * @returns AistudioAiStudioResponseListChatAttachmentDto OK
 * @throws ApiError
 */
export function listChatAttachment(
    {
        chatKey,
    }: {
        chatKey: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListChatAttachmentDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/attachments/v1',
                query: {
                    chatKey: chatKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 첨부파일 삭제
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function deleteChatAttachment(
    {
        chatKey,
        fileKey,
        categoryId,
    }: {
        chatKey: string;
        fileKey: string;
        categoryId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/chats/attachments/v1',
                query: {
                    chatKey: chatKey,
                    fileKey: fileKey,
                    categoryId: categoryId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 유저의 가장 최근 필터 조회 V3
 * @returns AistudioAiStudioResponseChatRecentFilterDto OK
 * @throws ApiError
 */
export function getChatRecentFilterV3(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseChatRecentFilterDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/recent-filter/v3',
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 유저의 가장 최근 필터 수정 V3
 * @returns AistudioAiStudioResponseChatRecentFilterDto OK
 * @throws ApiError
 */
export function updateChatRecentFilter(
    {
        requestBody,
    }: {
        requestBody: AistudioChatRecentFilterForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseChatRecentFilterDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/chats/recent-filter/v3',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 메시지 피드백 조회
 * @returns AistudioAiStudioResponseListChatMessageFeedbackDto OK
 * @throws ApiError
 */
export function listFeedback(
    {
        chatKey,
        chatMessageKey,
    }: {
        chatKey: string;
        chatMessageKey: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListChatMessageFeedbackDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/{chatKey}/messages/{chatMessageKey}/feedback/v1',
                path: {
                    chatKey: chatKey,
                    chatMessageKey: chatMessageKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 메시지 피드백
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function createFeedback(
    {
        chatKey,
        chatMessageKey,
        requestBody,
    }: {
        chatKey: string;
        chatMessageKey: string;
        requestBody: AistudioChatMessageFeedbackForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/chats/{chatKey}/messages/{chatMessageKey}/feedback/v1',
                path: {
                    chatKey: chatKey,
                    chatMessageKey: chatMessageKey,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 쿼리 v4
 * @returns AistudioChatQueryDtoV2 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function processChatQueryV4(
    {
        requestBody,
    }: {
        requestBody: AistudioChatQueryFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioChatQueryDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/chats/query/v4',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 쿼리 v3
 * @returns AistudioChatQueryDtoV2 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function processChatQueryV3(
    {
        requestBody,
    }: {
        requestBody: AistudioChatQueryFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioChatQueryDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/chats/query/v3',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 파일 OCR
 * @returns AistudioAiStudioResponseChatDocumentOcrResultDto OK
 * @throws ApiError
 */
export function ocrChatDocument(
    {
        collectionId,
        documentId,
        pageStart,
        pageEnd,
    }: {
        /**
         * 데이터베이스 ID
         */
        collectionId: string;
        /**
         * 도큐먼트 ID
         */
        documentId: string;
        /**
         * 시작 페이지
         */
        pageStart?: number;
        /**
         * 종료 페이지
         */
        pageEnd?: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseChatDocumentOcrResultDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/{collectionId}/{documentId}/ocr/v1',
                path: {
                    collectionId: collectionId,
                    documentId: documentId,
                },
                query: {
                    pageStart: pageStart,
                    pageEnd: pageEnd,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * Chat 파일 다운로드
 * @returns AistudioStreamingResponseBody OK
 * @throws ApiError
 */
export function downloadChatDocument(
    {
        collectionId,
        documentId,
        pageStart,
        pageEnd,
    }: {
        /**
         * 데이터베이스 ID
         */
        collectionId: string;
        /**
         * 도큐먼트 ID
         */
        documentId: string;
        /**
         * 시작 페이지
         */
        pageStart?: number;
        /**
         * 종료 페이지
         */
        pageEnd?: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioStreamingResponseBody> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/{collectionId}/{documentId}/download/v1',
                path: {
                    collectionId: collectionId,
                    documentId: documentId,
                },
                query: {
                    pageStart: pageStart,
                    pageEnd: pageEnd,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 조회
 * @returns AistudioAiStudioResponseChatDetailDtoV2 OK
 * @throws ApiError
 */
export function getChatV2(
    {
        chatKey,
    }: {
        chatKey: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseChatDetailDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/{chatKey}/v2',
                path: {
                    chatKey: chatKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * Chat 조회
 * @returns AistudioAiStudioResponseChatDetailDto OK
 * @throws ApiError
 */
export function getChat(
    {
        chatKey,
    }: {
        chatKey: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseChatDetailDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/{chatKey}/v1',
                path: {
                    chatKey: chatKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 삭제
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function deleteChat(
    {
        chatKey,
    }: {
        chatKey: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/chats/{chatKey}/v1',
                path: {
                    chatKey: chatKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 페이징 조회 V3
 * @returns AistudioAiStudioResponsePageChatDtoV3 OK
 * @throws ApiError
 */
export function pageChatByConditionV3(
    {
        updatedDateStart,
        updatedDateEnd,
        keyword,
        taskType,
        workspaceWorkflowIds,
        page,
        size = 10,
        sort,
    }: {
        /**
         * 조회 시작일
         */
        updatedDateStart?: string;
        /**
         * 조회 종료일
         */
        updatedDateEnd?: string;
        /**
         * 검색어
         */
        keyword?: string;
        /**
         * 챗 태스크 타입
         */
        taskType?: 'CHAT' | 'WORKFLOW' | 'AGENT';
        /**
         * 워크스페이스 워크플로우 ID
         */
        workspaceWorkflowIds?: Array<number>;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponsePageChatDtoV3> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/v3',
                query: {
                    updatedDateStart: updatedDateStart,
                    updatedDateEnd: updatedDateEnd,
                    keyword: keyword,
                    taskType: taskType,
                    workspaceWorkflowIds: workspaceWorkflowIds,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 페이징 조회 V2
 * @returns AistudioAiStudioResponsePageChatDtoV2 OK
 * @throws ApiError
 */
export function pageChatByConditionV2(
    {
        updatedDateStart,
        updatedDateEnd,
        page,
        size = 10,
        sort,
    }: {
        /**
         * 조회 시작일
         */
        updatedDateStart?: string;
        /**
         * 조회 종료일
         */
        updatedDateEnd?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponsePageChatDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/v2',
                query: {
                    updatedDateStart: updatedDateStart,
                    updatedDateEnd: updatedDateEnd,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 페이징 조회
 * @returns AistudioAiStudioResponsePageChatDto OK
 * @throws ApiError
 */
export function pageChatByCondition(
    {
        updatedDateStart,
        updatedDateEnd,
        page,
        size = 10,
        sort,
    }: {
        /**
         * 조회 시작일
         */
        updatedDateStart?: string;
        /**
         * 조회 종료일
         */
        updatedDateEnd?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponsePageChatDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/v1',
                query: {
                    updatedDateStart: updatedDateStart,
                    updatedDateEnd: updatedDateEnd,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 일 Chat 건수 조회
 * @returns AistudioAiStudioResponseChatUsageDto OK
 * @throws ApiError
 */
export function getChatUsageToday(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseChatUsageDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/usage/today',
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 유저의 가장 최근 필터 조회 V2
 * @returns AistudioAiStudioResponseChatRecentFilterDto OK
 * @throws ApiError
 */
export function getChatRecentFilter(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseChatRecentFilterDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/recent-filter/v2',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * Chat 유저의 가장 최근 필터 조회
 * @returns AistudioAiStudioResponseChatFilterDto OK
 * @throws ApiError
 */
export function getRecentFilter(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseChatFilterDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/recent-filter/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * Chat 파일 다운로드 - by 카테고리
 * @returns AistudioStreamingResponseBody OK
 * @throws ApiError
 */
export function downloadChatDocumentByCategory(
    {
        categoryId,
        documentId,
        pageStart,
        pageEnd,
    }: {
        /**
         * 카테고리 ID
         */
        categoryId: number;
        /**
         * 도큐먼트 ID
         */
        documentId: string;
        /**
         * 시작 페이지
         */
        pageStart?: number;
        /**
         * 종료 페이지
         */
        pageEnd?: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioStreamingResponseBody> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/chats/documents/download/by-category/v1',
                query: {
                    categoryId: categoryId,
                    documentId: documentId,
                    pageStart: pageStart,
                    pageEnd: pageEnd,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 문서 조회
 * @returns AistudioAiStudioResponseDocumentDetailDto OK
 * @throws ApiError
 */
export function getDocument(
    {
        collectionId,
        documentId,
    }: {
        /**
         * 데이터베이스 ID
         */
        collectionId: string;
        /**
         * 도큐먼트 ID
         */
        documentId: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseDocumentDetailDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/documents/v1',
                query: {
                    collectionId: collectionId,
                    documentId: documentId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 파일 다운로드 - by collection
 * @returns AistudioStreamingResponseBody OK
 * @throws ApiError
 */
export function downloadDocumentByCollection(
    {
        collectionId,
        documentId,
        pageStart,
        pageEnd,
    }: {
        /**
         * 데이터베이스 ID
         */
        collectionId: string;
        /**
         * 도큐먼트 ID
         */
        documentId: string;
        /**
         * 시작 페이지
         */
        pageStart?: number;
        /**
         * 종료 페이지
         */
        pageEnd?: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioStreamingResponseBody> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/documents/download/by-collection/v1',
                query: {
                    collectionId: collectionId,
                    documentId: documentId,
                    pageStart: pageStart,
                    pageEnd: pageEnd,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 파일 다운로드 - by 카테고리
 * @returns AistudioStreamingResponseBody OK
 * @throws ApiError
 */
export function downloadDocumentByCategory(
    {
        categoryId,
        documentId,
        pageStart,
        pageEnd,
    }: {
        /**
         * 카테고리 ID
         */
        categoryId: number;
        /**
         * 도큐먼트 ID
         */
        documentId: string;
        /**
         * 시작 페이지
         */
        pageStart?: number;
        /**
         * 종료 페이지
         */
        pageEnd?: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioStreamingResponseBody> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/documents/download/by-category/v1',
                query: {
                    categoryId: categoryId,
                    documentId: documentId,
                    pageStart: pageStart,
                    pageEnd: pageEnd,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @returns AistudioAiStudioResponseListWorkspaceWorkflowDto OK
 * @throws ApiError
 */
export function listBuiltInWorkflows1(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListWorkspaceWorkflowDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/external/built-in/workflows/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * @returns AistudioAiStudioResponseWorkspaceWorkflowSimpleDto OK
 * @throws ApiError
 */
export function createBuiltInWorkflow1(
    {
        requestBody,
    }: {
        requestBody: AistudioWorkspaceWorkflowForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseWorkspaceWorkflowSimpleDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/external/built-in/workflows/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @returns string OK
 * @throws ApiError
 */
export function hello(_?: any, requestConfig?: RequestConfig): AxiosPromise<string> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/hello',
            }),
            requestConfig,
        ),
    );
}
/**
 * 법령 검색
 * @returns AistudioAiStudioResponseLawSearchResponseDto OK
 * @throws ApiError
 */
export function searchStatutes(
    {
        requestBody,
    }: {
        requestBody: AistudioLawSearchRequest;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseLawSearchResponseDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/laws/search-tools/statutes/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 판례 검색
 * @returns AistudioAiStudioResponseLawSearchResponseDto OK
 * @throws ApiError
 */
export function searchPrecedents(
    {
        requestBody,
    }: {
        requestBody: AistudioLawSearchRequest;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseLawSearchResponseDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/laws/search-tools/precedents/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Assign legal expert
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function assignLegalExpert(
    {
        requestBody,
    }: {
        requestBody: AistudioLegalExpertAssignForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/legal-experts/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Revoke legal expert
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function revokeLegalExpert(
    {
        requestBody,
    }: {
        requestBody: AistudioLegalExpertRevokeForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/legal-experts/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 법률 전문가 인증 요청
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function requestLegalExperts(
    {
        requestBody,
    }: {
        requestBody: AistudioLegalExpertRequestForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/legal-experts/requests/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 내 법률 전문가 인증 요청 조회 - 마지막 인증 요청
 * @returns AistudioAiStudioResponseSimpleLegalExpertRequestDto OK
 * @throws ApiError
 */
export function getMyLegalExpertRequest(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseSimpleLegalExpertRequestDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/legal-experts/my/requests/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * @returns AistudioAiStudioResponseLegalHierarchyDto OK
 * @throws ApiError
 */
export function getLegalHierarchy(
    {
        statuteId,
    }: {
        statuteId: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseLegalHierarchyDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/statutes/{statuteId}/legal-hierarchies/v1',
                path: {
                    statuteId: statuteId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @returns AistudioAiStudioResponseLocalOrdinanceDto OK
 * @throws ApiError
 */
export function getLocalOrdinance(
    {
        govId,
        serialNumber,
    }: {
        govId: string;
        serialNumber: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseLocalOrdinanceDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/local-ordinances/v1',
                query: {
                    govId: govId,
                    serialNumber: serialNumber,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @returns AistudioAiStudioResponseMapStringListObject OK
 * @throws ApiError
 */
export function getMeta(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseMapStringListObject> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/meta/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 사용자의 AI 프롬프트 수정
 * @returns AistudioAiStudioResponseUserAiPromptCreatedDto OK
 * @throws ApiError
 */
export function updateUserPrompt(
    {
        promptId,
        requestBody,
    }: {
        promptId: number;
        requestBody: AistudioUserAiPromptUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseUserAiPromptCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/user/prompts/{promptId}/v1',
                path: {
                    promptId: promptId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 사용자 프롬프트 수정
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function updateUserPrompt_GL21(
    {
        promptId,
        requestBody,
    }: {
        promptId: number;
        requestBody: AistudioUserPromptForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/prompts/{promptId}/v1',
                path: {
                    promptId: promptId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 사용자 프롬프트 삭제
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function deleteUserPrompt(
    {
        promptId,
    }: {
        promptId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/prompts/{promptId}/v1',
                path: {
                    promptId: promptId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 사용자의 AI 프롬프트 조회
 * @returns AistudioAiStudioResponseListUserAiPromptDto OK
 * @throws ApiError
 */
export function getUserPrompts(
    {
        userId,
    }: {
        userId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListUserAiPromptDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/user/prompts/v1',
                query: {
                    userId: userId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 사용자의 AI 프롬프트 생성
 * @returns AistudioAiStudioResponseUserAiPromptCreatedDto OK
 * @throws ApiError
 */
export function createUserPrompt(
    {
        requestBody,
    }: {
        requestBody: AistudioUserAiPromptCreateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseUserAiPromptCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/user/prompts/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 사용자 프롬프트 조회
 * @returns AistudioAiStudioResponseListUserPromptDto OK
 * @throws ApiError
 */
export function getUserPrompts_YCTH(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListUserPromptDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/prompts/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 사용자 프롬프트 저장
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function createUserPrompt_VBFP(
    {
        requestBody,
    }: {
        requestBody: AistudioUserPromptForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/prompts/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 샘플 질문 리스트 조회
 * 샘플 질문 리스트 조회
 * @returns AistudioAiStudioResponseListString OK
 * @throws ApiError
 */
export function listSampleQuestionsByLocale(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListString> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/sample-questions/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 검색 V2
 * @returns AistudioAiStudioResponseListSearchQueryDto OK
 * @throws ApiError
 */
export function searchQueryV2(
    {
        requestBody,
        page,
        size = 10,
        sort,
    }: {
        requestBody: AistudioSearchQueryV2Form;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListSearchQueryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/searches/query/v2',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 검색
 * @returns AistudioAiStudioResponseListSearchQueryDto OK
 * @throws ApiError
 */
export function searchQueryV1(
    {
        requestBody,
        page,
        size = 10,
        sort,
    }: {
        requestBody: AistudioSearchQueryForm;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListSearchQueryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/searches/query/v1',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 카테고리 상세 조회
 * @returns AistudioAiStudioResponseAiCategoryDetailDto OK
 * @throws ApiError
 */
export function getCategory(
    {
        categoryId,
    }: {
        categoryId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseAiCategoryDetailDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/categories/{categoryId}/v1',
                path: {
                    categoryId: categoryId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 카테고리 수정 (custom)
 * @returns AistudioAiStudioResponseAiCategoryDto OK
 * @throws ApiError
 */
export function updateCategory(
    {
        categoryId,
        requestBody,
    }: {
        categoryId: number;
        requestBody: AistudioAiCategoryUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseAiCategoryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/categories/{categoryId}/v1',
                path: {
                    categoryId: categoryId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 자문 초안 생성하기
 * @returns AistudioAdvisoryDraftDtoV1 자문 초안 생성 결과를 event-stream으로 전송한다.
 * @throws ApiError
 */
export function generateAdvisoryDraft(
    {
        inquiryId,
        requestBody,
    }: {
        /**
         * 유사자문 질의 ID
         */
        inquiryId: number;
        requestBody: AistudioAdvisoryDraftFormV1;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAdvisoryDraftDtoV1> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/similar-advisory/inquires/{inquiryId}/drafts/v1',
                path: {
                    inquiryId: inquiryId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 유사자문질의 목록 조회하기(페이징)
 * @returns AistudioAiStudioResponsePageAdvisorySimpleDtoV1 OK
 * @throws ApiError
 */
export function pageAdvisories(
    {
        pageable,
        updatedDateStart,
        updatedDateEnd,
    }: {
        pageable: AistudioPageable;
        /**
         * 조회 시작일
         */
        updatedDateStart?: string;
        /**
         * 조회 종료일
         */
        updatedDateEnd?: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponsePageAdvisorySimpleDtoV1> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/similar-advisory/inquires/v1',
                query: {
                    updatedDateStart: updatedDateStart,
                    updatedDateEnd: updatedDateEnd,
                    pageable: pageable,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 유사자문 질의하기
 * @returns AistudioAdvisoryInquiryDtoV1 유사자문 질의 결과를 event-stream으로 전송한다.
 * @throws ApiError
 */
export function inquiryAdvisory(
    {
        requestBody,
    }: {
        requestBody: AistudioAdvisoryInquiryFormV1;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAdvisoryInquiryDtoV1> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/similar-advisory/inquires/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 자문 초안을 워드로 다운로드하기
 * @returns AistudioStreamingResponseBody OK
 * @throws ApiError
 */
export function downloadDraft(
    {
        requestBody,
    }: {
        requestBody: AistudioDraftDownloadFormV1;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioStreamingResponseBody> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/similar-advisory/download-draft/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 외부 API 호출 로그 기록
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function createExternalHttpLog(
    {
        requestBody,
    }: {
        requestBody: AistudioExternalHttpLogCreateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/external-logs/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 카테고리 내 쿼리 검색
 * @returns AistudioAiStudioResponsePageAiCategorySearchQueryDto OK
 * @throws ApiError
 */
export function searchQuery(
    {
        categoryId,
        requestBody,
        page,
        size = 10,
        sort,
    }: {
        categoryId: number;
        requestBody: AistudioAiCategorySearchQueryForm;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponsePageAiCategorySearchQueryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/categories/{categoryId}/query/v1',
                path: {
                    categoryId: categoryId,
                },
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 파일 업로드
 * @returns AistudioAiStudioResponseAiCategoryDocumentUploadedDto OK
 * @throws ApiError
 */
export function uploadDocument(
    {
        categoryId,
        formData,
    }: {
        /**
         * 카테고리 ID
         */
        categoryId: number;
        formData?: {
            form: AistudioAiCategoryDocumentCreateForm;
            /**
             * file
             */
            file: Blob;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseAiCategoryDocumentUploadedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/categories/{categoryId}/documents/by-file/v1',
                path: {
                    categoryId: categoryId,
                },
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 워크스페이스별 카테고리 목록 조회
 * @returns AistudioAiStudioResponseListAiCategoryDto OK
 * @throws ApiError
 */
export function getWorkspaceCategories(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListAiCategoryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/categories/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 카테고리 생성 (custom)
 * @returns AistudioAiStudioResponseAiCategoryDto OK
 * @throws ApiError
 */
export function createCategory(
    {
        requestBody,
    }: {
        requestBody: AistudioAiCategoryCreateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseAiCategoryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/categories/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 유사자문질의 상세 조회하기
 * @returns AistudioAiStudioResponseAdvisoryDtoV1 OK
 * @throws ApiError
 */
export function getAdvisory(
    {
        inquiryId,
    }: {
        inquiryId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseAdvisoryDtoV1> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/similar-advisory/inquires/{inquiryId}/v1',
                path: {
                    inquiryId: inquiryId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * LLM 호출량 조회
 * @returns AistudioAiStudioResponseListDashboardLlmDto OK
 * @throws ApiError
 */
export function getLlmSummary(
    {
        dateStart,
        dateEnd,
    }: {
        /**
         * 조회 시작일
         */
        dateStart?: string;
        /**
         * 조회 종료일
         */
        dateEnd?: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListDashboardLlmDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/dashboards/llm/v1',
                query: {
                    dateStart: dateStart,
                    dateEnd: dateEnd,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 설정 조회 V2
 * @returns AistudioAiStudioResponseWorkspaceConfigDtoV2 OK
 * @throws ApiError
 */
export function getConfigV2(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseWorkspaceConfigDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/configs/v2',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 설정 조회
 * @returns AistudioAiStudioResponseWorkspaceConfigDto OK
 * @throws ApiError
 */
export function getConfig(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseWorkspaceConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/configs/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 파일 처리 상태 확인
 * @returns AistudioAiStudioResponseAiCategoryDocumentStatusDto OK
 * @throws ApiError
 */
export function getDocumentStatus(
    {
        categoryId,
        documentId,
    }: {
        /**
         * 카테고리 ID
         */
        categoryId: number;
        /**
         * 도큐먼트 ID
         */
        documentId: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseAiCategoryDocumentStatusDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/categories/{categoryId}/documents/{documentId}/status/v1',
                path: {
                    categoryId: categoryId,
                    documentId: documentId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 파일 다운로드
 * @returns AistudioStreamingResponseBody OK
 * @throws ApiError
 */
export function downloadDocument(
    {
        categoryId,
        documentId,
    }: {
        /**
         * 카테고리 ID
         */
        categoryId: number;
        /**
         * 도큐먼트 ID
         */
        documentId: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioStreamingResponseBody> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/categories/{categoryId}/documents/{documentId}/download/v1',
                path: {
                    categoryId: categoryId,
                    documentId: documentId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 파일 목록 조회 (paging)
 * @returns AistudioAiStudioResponsePageAiCategoryDocumentDto OK
 * @throws ApiError
 */
export function pageDocuments(
    {
        categoryId,
        pageable,
    }: {
        /**
         * 카테고리 ID
         */
        categoryId: number;
        pageable: AistudioPageable;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponsePageAiCategoryDocumentDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/categories/{categoryId}/documents/v1',
                path: {
                    categoryId: categoryId,
                },
                query: {
                    pageable: pageable,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 파일 삭제
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function deleteDocuments(
    {
        categoryId,
        requestBody,
    }: {
        /**
         * 카테고리 ID
         */
        categoryId: number;
        requestBody: AistudioAiCategoryDocumentDeleteForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/categories/{categoryId}/documents/v1',
                path: {
                    categoryId: categoryId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스별 카테고리 목록 조회 V2
 * @returns AistudioAiStudioResponseListAiCategoryWithTagDto OK
 * @throws ApiError
 */
export function getWorkspaceCategoriesV2(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListAiCategoryWithTagDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/categories/v2',
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스의 세션용 카테고리 조회
 * @returns AistudioAiStudioResponseAiCategoryDto OK
 * @throws ApiError
 */
export function getSessionCategory(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseAiCategoryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/categories/session/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 카테고리 목록 페이징 조회
 * @returns AistudioAiStudioResponsePageAiCategoryOverviewDto OK
 * @throws ApiError
 */
export function pageByCondition(
    {
        searchKeyword,
        page,
        size = 10,
        sort,
    }: {
        /**
         * 검색 키워드
         */
        searchKeyword?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponsePageAiCategoryOverviewDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/categories/search/v1',
                query: {
                    searchKeyword: searchKeyword,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 카테고리 메타 조회
 * @returns AistudioAiStudioResponseMapStringListObject OK
 * @throws ApiError
 */
export function getCategoryMeta(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseMapStringListObject> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/categories/meta/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 카테고리 용량 조회
 * @returns AistudioAiStudioResponseAiCategoryCapacityDto OK
 * @throws ApiError
 */
export function getCapacity(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseAiCategoryCapacityDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/categories/capacity/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-in) Workflow Group - active on/off by workspace
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function updateWorkspaceBuiltInWorkflowGroupActive(
    {
        workspaceId,
        workflowGroupId,
        active,
    }: {
        workspaceId: number;
        workflowGroupId: number;
        active: 'ON' | 'OFF';
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/workspaces/{workspaceId}/built-in/workflows/groups/{workflowGroupId}/active/{active}/v1',
                path: {
                    workspaceId: workspaceId,
                    workflowGroupId: workflowGroupId,
                    active: active,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Built-in Workflow 조회 by ID
 * @returns AistudioAiStudioResponseWorkspaceWorkflowDetailDto OK
 * @throws ApiError
 */
export function getBuiltInWorkflowById(
    {
        workspaceWorkflowId,
    }: {
        workspaceWorkflowId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseWorkspaceWorkflowDetailDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/built-in/workflows/{workspaceWorkflowId}/v1',
                path: {
                    workspaceWorkflowId: workspaceWorkflowId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-in) Workflow 수정
 * @returns AistudioAiStudioResponseWorkspaceWorkflowDto OK
 * @throws ApiError
 */
export function updateBuiltInWorkflowInfo(
    {
        workspaceWorkflowId,
        requestBody,
    }: {
        workspaceWorkflowId: number;
        requestBody: AistudioWorkspaceWorkflowUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseWorkspaceWorkflowDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/built-in/workflows/{workspaceWorkflowId}/v1',
                path: {
                    workspaceWorkflowId: workspaceWorkflowId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-In) Active Workflow 삭제
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function deleteBuiltInWorkflow(
    {
        workspaceWorkflowId,
    }: {
        workspaceWorkflowId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/super-admin/built-in/workflows/{workspaceWorkflowId}/v1',
                path: {
                    workspaceWorkflowId: workspaceWorkflowId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Workflow Node Registry(prompt) 수정 V2
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function updateWorkflowNodeRegistriesV2(
    {
        workspaceWorkflowId,
        nodeId,
        requestBody,
    }: {
        workspaceWorkflowId: number;
        nodeId: string;
        requestBody: AistudioWorkflowNodeRegistryUpdateFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/built-in/workflows/{workspaceWorkflowId}/nodes/{nodeId}/registries/v2',
                path: {
                    workspaceWorkflowId: workspaceWorkflowId,
                    nodeId: nodeId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * Workflow Node Registry(prompt) 수정
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function updateWorkflowNodeRegistries(
    {
        workspaceWorkflowId,
        nodeId,
        requestBody,
    }: {
        workspaceWorkflowId: number;
        nodeId: string;
        requestBody: AistudioWorkflowNodeRegistryUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/built-in/workflows/{workspaceWorkflowId}/nodes/{nodeId}/registries/v1',
                path: {
                    workspaceWorkflowId: workspaceWorkflowId,
                    nodeId: nodeId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-in) Workflow Group 내 Workflow 리스트 overwrite
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function overwriteBuiltInWorkflowGroupWorkflows(
    {
        workflowGroupId,
        requestBody,
    }: {
        workflowGroupId: number;
        requestBody: AistudioWorkflowGroupWorkflowOverwriteForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/built-in/workflows/groups/{workflowGroupId}/workflows/overwrites/v1',
                path: {
                    workflowGroupId: workflowGroupId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-in) Workflow Group - global on/off
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function updateBuiltInWorkflowGroupGlobal(
    {
        workflowGroupId,
        global,
    }: {
        workflowGroupId: number;
        global: 'ON' | 'OFF';
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/built-in/workflows/groups/{workflowGroupId}/global/{global}/v1',
                path: {
                    workflowGroupId: workflowGroupId,
                    global: global,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-in) Workflow 리스트 조회
 * @returns AistudioAiStudioResponseListWorkspaceWorkflowDto OK
 * @throws ApiError
 */
export function listBuiltInWorkflows(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListWorkspaceWorkflowDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/built-in/workflows/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-in) Workflow 추가
 * @returns AistudioAiStudioResponseWorkspaceWorkflowSimpleDto OK
 * @throws ApiError
 */
export function createBuiltInWorkflow(
    {
        requestBody,
    }: {
        requestBody: AistudioWorkspaceWorkflowForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseWorkspaceWorkflowSimpleDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/built-in/workflows/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-In) Workflow 생성 유형 리스트 조회
 * @returns AistudioAiStudioResponseListWorkflowTypeDto OK
 * @throws ApiError
 */
export function listBuiltInWorkflowTypes(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListWorkflowTypeDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/built-in/workflows/types/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-In) Workflow 생성 유형 생성
 * @returns AistudioAiStudioResponseListWorkflowTypeDto OK
 * @throws ApiError
 */
export function createBuiltInWorkflowTypes(
    {
        requestBody,
    }: {
        requestBody: Array<AistudioWorkflowTypeForm>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListWorkflowTypeDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/built-in/workflows/types/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-In) Workflow Group 전체 리스트 조회
 * @returns AistudioAiStudioResponseListWorkflowGroupDto OK
 * @throws ApiError
 */
export function listAllBuiltInWorkflowGroups(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListWorkflowGroupDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/built-in/workflows/groups/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-in) Workflow Group 추가
 * @returns AistudioAiStudioResponseWorkflowGroupSimpleDto OK
 * @throws ApiError
 */
export function createBuiltInWorkflowGroup(
    {
        requestBody,
    }: {
        requestBody: AistudioWorkflowGroupForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseWorkflowGroupSimpleDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/built-in/workflows/groups/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Allibee(Built-In) Active Workflow Group 리스트 조회 - by Workspace
 * @returns AistudioAiStudioResponseListWorkflowGroupDto OK
 * @throws ApiError
 */
export function listActiveBuiltInWorkflowGroupsByWorkspaceId(
    {
        workspaceId,
    }: {
        workspaceId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListWorkflowGroupDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/workspaces/{workspaceId}/built-in/workflows/active/groups/v1',
                path: {
                    workspaceId: workspaceId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Workflow Node Registry(prompt) 조회 V2
 * @returns AistudioAiStudioResponseWorkflowNodeRegistryDtoV2 OK
 * @throws ApiError
 */
export function getWorkflowNodeRegistriesV2(
    {
        workspaceWorkflowId,
    }: {
        workspaceWorkflowId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseWorkflowNodeRegistryDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/built-in/workflows/{workspaceWorkflowId}/nodes/registries/v2',
                path: {
                    workspaceWorkflowId: workspaceWorkflowId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Workflow Node Registry(prompt) 조회
 * @returns AistudioAiStudioResponseWorkflowNodeRegistryDto OK
 * @throws ApiError
 */
export function getWorkflowNodeRegistries(
    {
        workspaceWorkflowId,
    }: {
        workspaceWorkflowId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseWorkflowNodeRegistryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/built-in/workflows/{workspaceWorkflowId}/nodes/registries/v1',
                path: {
                    workspaceWorkflowId: workspaceWorkflowId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 메시지 상세 조회 (chatMessageKey 기반)
 * @returns AistudioAiStudioResponseSuperAdminChatMessageDetailDtoV3 OK
 * @throws ApiError
 */
export function getChatMessageV3(
    {
        chatMessageKey,
    }: {
        chatMessageKey: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseSuperAdminChatMessageDetailDtoV3> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/chats/messages/{chatMessageKey}/v3',
                path: {
                    chatMessageKey: chatMessageKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Chat 메시지 조회
 * @returns AistudioAiStudioResponseSuperAdminChatMessageDetailDtoV2 OK
 * @throws ApiError
 */
export function getChatMessageV2(
    {
        chatMessageId,
    }: {
        chatMessageId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseSuperAdminChatMessageDetailDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/chats/messages/{chatMessageId}/v2',
                path: {
                    chatMessageId: chatMessageId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * Chat 메시지 조회
 * @returns AistudioAiStudioResponseSuperAdminChatMessageDetailDto OK
 * @throws ApiError
 */
export function getChatMessage(
    {
        chatMessageId,
    }: {
        chatMessageId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseSuperAdminChatMessageDetailDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/chats/messages/{chatMessageId}/v1',
                path: {
                    chatMessageId: chatMessageId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 메시지 목록 조회 (대화 + 에이전트 통합)
 * @returns AistudioAiStudioResponsePageSuperAdminChatMessageDtoV2 OK
 * @throws ApiError
 */
export function listChatMessagesByConditionV2(
    {
        updatedDateStart,
        updatedDateEnd,
        workspaceId,
        page,
        size = 10,
        sort,
    }: {
        /**
         * 조회 시작일
         */
        updatedDateStart: string;
        /**
         * 조회 종료일
         */
        updatedDateEnd: string;
        /**
         * 워크스페이스 ID
         */
        workspaceId?: number;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponsePageSuperAdminChatMessageDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/chats/messages/v2',
                query: {
                    updatedDateStart: updatedDateStart,
                    updatedDateEnd: updatedDateEnd,
                    workspaceId: workspaceId,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 메시지 목록 조회
 * @returns AistudioAiStudioResponsePageSuperAdminChatMessageDto OK
 * @throws ApiError
 */
export function pageChatMessagesByCondition(
    {
        updatedDateStart,
        updatedDateEnd,
        workspaceId,
        page,
        size = 10,
        sort,
    }: {
        /**
         * 조회 시작일
         */
        updatedDateStart: string;
        /**
         * 조회 종료일
         */
        updatedDateEnd: string;
        /**
         * 워크스페이스 ID
         */
        workspaceId?: number;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponsePageSuperAdminChatMessageDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/chats/messages/v1',
                query: {
                    updatedDateStart: updatedDateStart,
                    updatedDateEnd: updatedDateEnd,
                    workspaceId: workspaceId,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Assign legal expert V2
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function assignWorkspaceLegalExpertV2(
    {
        requestBody,
    }: {
        requestBody: AistudioLegalExpertAssignForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/legal-experts/v2',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Revoke legal expert V2
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function revokeWorkspaceLegalExpertV2(
    {
        requestBody,
    }: {
        requestBody: AistudioLegalExpertRevokeForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/super-admin/legal-experts/v2',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * Assign legal expert
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function assignWorkspaceLegalExpert(
    {
        requestBody,
    }: {
        requestBody: AistudioWorkspaceLegalExpertAssignForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/legal-experts/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * Revoke legal expert
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function revokeWorkspaceLegalExpert(
    {
        requestBody,
    }: {
        requestBody: AistudioWorkspaceLegalExpertRevokeForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/super-admin/legal-experts/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Reject legal expert request
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function rejectLegalExpertRequest(
    {
        legalExpertRequestId,
        requestBody,
    }: {
        legalExpertRequestId: number;
        requestBody: AistudioLegalExpertRequestReviewForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/legal-experts/requests/{legalExpertRequestId}/rejects/v1',
                path: {
                    legalExpertRequestId: legalExpertRequestId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Approve legal expert request
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function approveLegalExpertRequest(
    {
        legalExpertRequestId,
        requestBody,
    }: {
        legalExpertRequestId: number;
        requestBody: AistudioLegalExpertRequestApproveForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/legal-experts/requests/{legalExpertRequestId}/approve/v1',
                path: {
                    legalExpertRequestId: legalExpertRequestId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * get legal expert infos by user ids
 * @returns AistudioAiStudioResponseListLegalExpertDto OK
 * @throws ApiError
 */
export function getLegalExpertInfosByUserIds(
    {
        requestBody,
    }: {
        requestBody: AistudioLegalExpertUserIdsCondition;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListLegalExpertDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/legal-experts/by-user-ids/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * get Page of legal expert requests
 * @returns AistudioAiStudioResponsePageLegalExpertRequestDto OK
 * @throws ApiError
 */
export function pageLegalExpertRequests(
    {
        statuses,
        page,
        size = 10,
        sort,
    }: {
        statuses?: Array<'PENDING' | 'APPROVED' | 'REJECTED'>;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponsePageLegalExpertRequestDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/legal-experts/requests/v1',
                query: {
                    statuses: statuses,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * delete legal expert request
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function deleteLegalExpertRequest(
    {
        requestId,
    }: {
        requestId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/super-admin/legal-experts/requests/{requestId}/v1',
                path: {
                    requestId: requestId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @returns AistudioAiStudioResponseMapStringObject OK
 * @throws ApiError
 */
export function getSuperAdminMeta(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseMapStringObject> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/meta/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 슈퍼어드민 - 샘플 질문 리스트 조회
 * 슈퍼어드민 - 샘플 질문 리스트 조회
 * @returns AistudioAiStudioResponseListDefaultAiSampleQuestionSearchDto OK
 * @throws ApiError
 */
export function listSampleQuestions(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListDefaultAiSampleQuestionSearchDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/sample-questions/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 슈퍼어드민 - 샘플 질문 저장
 * 슈퍼어드민 - 샘플 질문 저장(Overwrite)
 * @returns AistudioAiStudioResponseListDefaultAiSampleQuestionDto OK
 * @throws ApiError
 */
export function saveSampleQuestions(
    {
        requestBody,
    }: {
        requestBody: AistudioDefaultAiSampleQuestionForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListDefaultAiSampleQuestionDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/sample-questions/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 프롬프트 수정
 * @returns AistudioAiStudioResponseSuperAdminWorkspaceAiPromptCreatedDto OK
 * @throws ApiError
 */
export function updateWorkspacePrompt(
    {
        promptId,
        requestBody,
    }: {
        promptId: number;
        requestBody: AistudioSuperAdminWorkspaceAiPromptUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseSuperAdminWorkspaceAiPromptCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/prompts/{promptId}/v1',
                path: {
                    promptId: promptId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 설정 조회 V2
 * @returns AistudioAiStudioResponseSuperAdminWorkspaceConfigDtoV2 OK
 * @throws ApiError
 */
export function getWorkspaceConfigV2(
    {
        tenantId,
        workspaceId,
    }: {
        tenantId: number;
        workspaceId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseSuperAdminWorkspaceConfigDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/configs/v2',
                query: {
                    tenantId: tenantId,
                    workspaceId: workspaceId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 설정 수정 V2
 * @returns AistudioAiStudioResponseSuperAdminWorkspaceConfigUpdatedDtoV2 OK
 * @throws ApiError
 */
export function updateWorkspaceConfigV2(
    {
        requestBody,
    }: {
        requestBody: AistudioSuperAdminWorkspaceConfigUpdateFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseSuperAdminWorkspaceConfigUpdatedDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/configs/v2',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 설정 조회
 * @returns AistudioAiStudioResponseSuperAdminWorkspaceConfigDto OK
 * @throws ApiError
 */
export function getWorkspaceConfig(
    {
        tenantId,
        workspaceId,
    }: {
        tenantId: number;
        workspaceId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseSuperAdminWorkspaceConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/configs/v1',
                query: {
                    tenantId: tenantId,
                    workspaceId: workspaceId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 설정 수정
 * @returns AistudioAiStudioResponseSuperAdminWorkspaceConfigUpdatedDto OK
 * @throws ApiError
 */
export function updateWorkspaceConfig(
    {
        requestBody,
    }: {
        requestBody: AistudioSuperAdminWorkspaceConfigUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseSuperAdminWorkspaceConfigUpdatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/configs/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스의 카테고리 목록 조회
 * @returns AistudioAiStudioResponseListSuperAdminAiCategoryOverviewDto OK
 * @throws ApiError
 */
export function getCategoriesByWorkspace(
    {
        workspaceId,
        serviceType,
    }: {
        workspaceId: number;
        serviceType: 'GENERAL' | 'WORKSPACE';
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListSuperAdminAiCategoryOverviewDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/categories/by-workspace/v1',
                query: {
                    workspaceId: workspaceId,
                    serviceType: serviceType,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스의 카테고리 목록 수정
 * @returns AistudioAiStudioResponse OK
 * @throws ApiError
 */
export function updateCategoriesByWorkspace(
    {
        requestBody,
    }: {
        requestBody: AistudioSuperAdminWorkspaceAiCategoryUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/categories/by-workspace/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 프롬프트 조회
 * @returns AistudioAiStudioResponseListSuperAdminWorkspaceAiPromptDto OK
 * @throws ApiError
 */
export function getWorkspacePrompts(
    {
        workspaceId,
    }: {
        workspaceId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListSuperAdminWorkspaceAiPromptDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/prompts/v1',
                query: {
                    workspaceId: workspaceId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 프롬프트 생성
 * @returns AistudioAiStudioResponseSuperAdminWorkspaceAiPromptCreatedDto OK
 * @throws ApiError
 */
export function createWorkspacePrompt(
    {
        requestBody,
    }: {
        requestBody: AistudioSuperAdminWorkspaceAiPromptCreateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseSuperAdminWorkspaceAiPromptCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/prompts/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 모델 목록 조회
 * @returns AistudioAiStudioResponseListAiModelDto OK
 * @throws ApiError
 */
export function getAvailableModels(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListAiModelDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/models/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 워크스페이스 설정 메타 조회
 * @returns AistudioAiStudioResponseMapStringListObject OK
 * @throws ApiError
 */
export function getGlobalWorkspaceConfigMeta(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseMapStringListObject> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/configs/meta/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 카테고리 서비스 타입 제어 가능 옵션 목록
 * @returns AistudioAiStudioResponseListEnumDto OK
 * @throws ApiError
 */
export function getAvailableCategoryTypes(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListEnumDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/configs/meta/categories/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 카테고리 메타 조회
 * @returns AistudioAiStudioResponseMapStringListObject OK
 * @throws ApiError
 */
export function getGlobalCategoryMeta(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseMapStringListObject> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/categories/meta/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 설정 가능한 외부 DB 카테고리 목록 조회
 * @returns AistudioAiStudioResponseListSuperAdminAiCategoryOverviewDto OK
 * @throws ApiError
 */
export function getAvailableGeneralCategories(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListSuperAdminAiCategoryOverviewDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/categories/general/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 참고자료 번역 스트리밍 API (SSE 방식)
 * @returns string 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function translateV1(
    {
        requestBody,
    }: {
        requestBody: AistudioTranslationForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<Array<string>> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/translations/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크플로우 실행 API
 * @returns string 결과를 실시간 event-stream으로 보낸다.
 * @throws ApiError
 */
export function runWorkflow(
    {
        workspaceWorkflowId,
        requestBody,
    }: {
        workspaceWorkflowId: number;
        requestBody: AistudioWorkflowRunRequestForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<string> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/workspaces/workflows/{workspaceWorkflowId}/v1',
                path: {
                    workspaceWorkflowId: workspaceWorkflowId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @returns AistudioAiWorkflowRouteResponse OK
 * @throws ApiError
 */
export function getWorkflowRoute(
    {
        requestBody,
    }: {
        requestBody: AistudioWorkflowRouteRequest;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<Array<AistudioAiWorkflowRouteResponse>> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/workspaces/workflows/routes/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크플로우 registry 조회 API
 * @returns AistudioAiStudioResponseAiWorkflowRegistryDto OK
 * @throws ApiError
 */
export function getWorkflowRegistry(
    {
        workspaceWorkflowId,
    }: {
        workspaceWorkflowId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseAiWorkflowRegistryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/workspaces/workflows/{workspaceWorkflowId}/registry/v1',
                path: {
                    workspaceWorkflowId: workspaceWorkflowId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크플로우 목록 조회 API
 * @returns AistudioAiStudioResponseListWorkspaceWorkflowDto OK
 * @throws ApiError
 */
export function getWorkflows(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListWorkspaceWorkflowDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/workspaces/workflows/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크플로우 Run history API
 * @returns AistudioAiStudioResponseListWorkflowRunHistoryDto OK
 * @throws ApiError
 */
export function getWorkflowRunHistories(
    {
        chatKey,
    }: {
        chatKey: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AistudioAiStudioResponseListWorkflowRunHistoryDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/workspaces/workflows/run-histories/{chatKey}/v1',
                path: {
                    chatKey: chatKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크플로 그룹 목록 조회 API
 * @returns AistudioAiStudioResponseListWorkflowGroupDto OK
 * @throws ApiError
 */
export function getWorkspaceWorkflowGroups(_?: any, requestConfig?: RequestConfig): AxiosPromise<AistudioAiStudioResponseListWorkflowGroupDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/workspaces/workflows/groups/v1',
            }),
            requestConfig,
        ),
    );
}
